// src/auth/msalConfig.js
const MICROSOFT_LOGIN_BASE = "https://login.microsoftonline.com";
const DEFAULT_MICROSOFT_TENANT = "common";

function cleanAuthority(authority) {
  return authority?.trim().replace(/\/+$/, "");
}

const configuredAuthority = cleanAuthority(
  process.env.REACT_APP_MICROSOFT_AUTHORITY,
);

const configuredTenant = (
  process.env.REACT_APP_MICROSOFT_TENANT || DEFAULT_MICROSOFT_TENANT
)
  .trim()
  .replace(/^\/+|\/+$/g, "");

// Outlook OAuth must use common/organizations because ProspectEngage is
// multi-tenant and clients authenticate with their own Microsoft tenants.
const microsoftAuthority =
  configuredAuthority || `${MICROSOFT_LOGIN_BASE}/${configuredTenant}`;

const MICROSOFT_TENANT_STORAGE_KEY = "microsoft_outlook_tenant_id";

function getMicrosoftTenantId(accountOrResponse) {
  const account = accountOrResponse?.account || accountOrResponse;
  return (
    account?.tenantId ||
    account?.idTokenClaims?.tid ||
    accountOrResponse?.tenantId ||
    accountOrResponse?.idTokenClaims?.tid ||
    null
  );
}

export function persistMicrosoftTenantId(accountOrResponse) {
  const tenantId = getMicrosoftTenantId(accountOrResponse);
  if (!tenantId) return null;

  localStorage.setItem(MICROSOFT_TENANT_STORAGE_KEY, tenantId);
  return tenantId;
}

export const msalConfig = {
  auth: {
    clientId: "1ade8916-ba45-4cee-8dc6-045d81a40ad3", // or from env
    authority: microsoftAuthority,
    redirectUri: `${window.location.origin}/auth`, // << if you prefer top-level, use `${window.location.origin}/auth`
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true, // return to page user started from
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true, // helps behind CloudFront/Safari
  },
};

export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "email",
    "User.Read",
    "Mail.Read",
    "Mail.ReadWrite",
    "Mail.Send",
    "Calendars.Read",
    "Calendars.ReadWrite",
    "offline_access",
  ],
};
